<template>
    <div v-if="token" class="hide-overflow"
         style="position: relative;">

        <v-toolbar fixed dark color="primary" clipped-right>
            <v-toolbar-title class="white--text">
                <a v-if="token&&back_item.title!='Service Excellence'" class="mr-2 pa-0" @click="goto(back_item.back_route,back_item.params)">
                    <v-icon>mdi-chevron-left</v-icon>

                    <span class="white--text">{{ back_item.title }}</span>
                </a>
                <span v-else class="white--text">{{ back_item.title }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-img
                    :src="require('@/assets/img/qr_code3.png')"
                    aspect-ratio="1"
                    max-height="25"
                    max-width="25"
                    v-ripple
                    @click="goto('qrscan')">
            </v-img>
            <v-toolbar-side-icon  @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>

            <v-toolbar-items v-for="item in items" :key="item.title" class="hidden-sm-and-down">
                <v-btn flat  to="" @click="goto(item.url)">{{ item.title }}</v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-navigation-drawer
                temporary
                v-model="drawer"
                fixed
                :hide-overlay="true"
                dark
                width = "200"
                id = "drawer"
                right
        >
            <div class="title pa-2 white--text">Menu</div>
            <v-list class="pt-0" dense>
                <v-divider></v-divider>
                <v-list-tile
                        v-for="item in items"
                        :key="item.title"
                        @click="goto(item.url)"
                >
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <div
                id="scrolling-techniques"
                class="scroll-y"
                style="max-height: 50px;"
        >
            <v-container style="height: 1000px;"></v-container>
        </div>

    </div>
</template>

<script>

    import EventBus from '@/EventBus'

    export default{

        props : {
            token:String,
            titleName:String,
            back_route:String
        },
        watch:{
            token(){
                this.authMenu()
            },
            user(){
                this.authMenu()
            },
            titleName(){
                this.back_item.title = this.titleName
            }
        },
        data(){
            return {
                drawer:null,
                right: null,
                items: [],
                back_item: {
                    title: 'Service Excellence', back_route: 'home',params:{}
                }

            }
        },
        mounted(){
            // let localitem = this.getLocalItem()
            // if (!localitem) {
            //     return this.$router.replace({name: 'login'})
            // }
            // if (localitem.availableUntil) {
            //     if (this.$moment().diff(localitem.availableUntil, 'second') > 0) {
            //         return this.$router.replace({name: 'login'})
            //     }
            // }
            // this.token = localitem.token

            this.authMenu()

            EventBus.$on('set_navigation', views_title => {
                this.back_item.title = views_title.title
                this.back_item.back_route = views_title.back_route
                this.back_item.params = views_title.params
            })

        },
        methods: {
            authMenu(){
                if(!this.token){
                    this.items = [
                        { title: 'เข้าสู่ระบบ', icon: 'mdi-login-variant',url:'login' }
                    ]
                }else{
                    this.items = [
                        { title: 'เมนูหลัก', icon: 'apps', url:'home' },
                        { title: 'เมนูอื่นๆ', icon: 'apps', url:'OtherMenu' },
                        // { title: 'ระบบประเมินพนักงาน', icon: 'mdi-star-face',url:'/empSearch' },
                        // { title: 'ระบบอื่นๆ 1', icon: 'mdi-help-circle-outline',url:'/' },
                        // { title: 'ระบบอื่นๆ 2', icon: 'mdi-help-circle-outline',url:'/' },
                        { title: 'ออกจากระบบ', icon: 'exit_to_app',url:'logout' }
                    ]
                }
            },
            goto(route_name,params){
                if(route_name=='logout'){
                    EventBus.$emit('resetToken')
                    return this.logout()
                }else {
                    if (params) {
                        EventBus.$emit(params.eventbus_call, params.params)
                    }
                    return this.$router.push({name: route_name})
                }
            }
        },
    }
</script>

<style>
</style>
